export default "__VITE_ASSET__wwjl28WQ__"